// import React, { useState, useEffect } from 'react';
// import { useParams, Link, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { format } from 'date-fns';

// const NewsDetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [news, setNews] = useState(null);
//   const [relatedNews, setRelatedNews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const API_BASE_URL = 'http://localhost:5000/api';

//   useEffect(() => {
//     fetchNewsDetail();
//   }, [id]);

//   const fetchNewsDetail = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${API_BASE_URL}/news/${id}`);
      
//       if (response.data.success) {
//         setNews(response.data.data);
//         // Fetch related news (same category, exclude current)
//         fetchRelatedNews(response.data.data.category);
//       }
//     } catch (err) {
//       console.error('Error fetching news:', err);
//       setError('Failed to load news article');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchRelatedNews = async (category) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/news?category=${category}&limit=3`);
//       if (response.data.success) {
//         // Filter out current news
//         const filtered = response.data.data.filter(item => item._id !== id);
//         setRelatedNews(filtered.slice(0, 3));
//       }
//     } catch (err) {
//       console.error('Error fetching related news:', err);
//     }
//   };

//   const formatDate = (dateString) => {
//     try {
//       return format(new Date(dateString), 'dd MMMM yyyy');
//     } catch {
//       return dateString;
//     }
//   };

//   const getCategoryIcon = (category) => {
//     const iconMap = {
//       'Industry News': '🏭',
//       'Company Updates': '🏢',
//       'Technology': '⚙️',
//       'Policy': '📜',
//       'Events': '🎉'
//     };
//     return iconMap[category] || '📰';
//   };

//   const styles = {
//     container: {
//       maxWidth: '1200px',
//       margin: '0 auto',
//       padding: '40px 20px',
//       fontFamily: 'Cambria, serif',
//       backgroundColor: '#ffffff',
//     },
    
//     // Back Button
//     backButton: {
//       display: 'inline-flex',
//       alignItems: 'center',
//       gap: '8px',
//       backgroundColor: 'transparent',
//       color: '#447793',
//       border: '2px solid #447793',
//       padding: '10px 20px',
//       borderRadius: '25px',
//       fontSize: '0.95rem',
//       fontWeight: '600',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//       textDecoration: 'none',
//       marginBottom: '30px',
//     },
    
//     // Main Content
//     mainContent: {
//       display: 'grid',
//       gridTemplateColumns: '2fr 1fr',
//       gap: '40px',
//     },
    
//     // Article Section
//     articleSection: {
//       backgroundColor: 'white',
//       borderRadius: '15px',
//       overflow: 'hidden',
//       boxShadow: '0 5px 20px rgba(6, 18, 33, 0.08)',
//       border: '1px solid #DDE8ED',
//     },
    
//     // Featured Image
//     featuredImage: {
//       width: '100%',
//       height: '400px',
//       objectFit: 'cover',
//     },
    
//     // Article Content
//     articleContent: {
//       padding: '30px',
//     },
    
//     // Meta Info
//     metaInfo: {
//       display: 'flex',
//       flexWrap: 'wrap',
//       gap: '20px',
//       marginBottom: '20px',
//       paddingBottom: '20px',
//       borderBottom: '1px solid #DDE8ED',
//     },
//     metaItem: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       color: '#2D5A74',
//       fontSize: '0.95rem',
//     },
//     categoryBadge: {
//       backgroundColor: '#447793',
//       color: 'white',
//       padding: '6px 15px',
//       borderRadius: '25px',
//       fontSize: '0.9rem',
//       fontWeight: '600',
//       display: 'inline-flex',
//       alignItems: 'center',
//       gap: '5px',
//     },
    
//     // Title
//     title: {
//       fontSize: '2.2rem',
//       fontWeight: '800',
//       color: '#123249',
//       marginBottom: '15px',
//       lineHeight: '1.3',
//     },
//     subtitle: {
//       fontSize: '1.3rem',
//       color: '#447793',
//       marginBottom: '20px',
//       fontStyle: 'italic',
//     },
    
//     // Content
//     content: {
//       fontSize: '1.1rem',
//       lineHeight: '1.8',
//       color: '#2D5A74',
//       marginBottom: '30px',
//       whiteSpace: 'pre-line',
//     },
    
//     // Source
//     sourceBox: {
//       backgroundColor: '#DDE8ED',
//       padding: '20px',
//       borderRadius: '10px',
//       marginTop: '30px',
//     },
//     sourceLink: {
//       color: '#123249',
//       textDecoration: 'none',
//       fontWeight: '600',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//     },
    
//     // Tags
//     tagsContainer: {
//       display: 'flex',
//       flexWrap: 'wrap',
//       gap: '10px',
//       marginTop: '20px',
//     },
//     tag: {
//       backgroundColor: '#DDE8ED',
//       color: '#123249',
//       padding: '6px 15px',
//       borderRadius: '25px',
//       fontSize: '0.85rem',
//       fontWeight: '600',
//     },
    
//     // Sidebar
//     sidebar: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '30px',
//     },
    
//     // Related News Card
//     relatedCard: {
//       backgroundColor: 'white',
//       borderRadius: '12px',
//       overflow: 'hidden',
//       boxShadow: '0 5px 15px rgba(6, 18, 33, 0.08)',
//       border: '1px solid #DDE8ED',
//       transition: 'all 0.3s ease',
//     },
//     relatedImage: {
//       width: '100%',
//       height: '150px',
//       objectFit: 'cover',
//     },
//     relatedContent: {
//       padding: '15px',
//     },
//     relatedTitle: {
//       fontSize: '1rem',
//       fontWeight: '700',
//       color: '#123249',
//       marginBottom: '8px',
//       lineHeight: '1.4',
//     },
//     relatedDate: {
//       color: '#2D5A74',
//       fontSize: '0.8rem',
//       marginBottom: '10px',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '5px',
//     },
//     relatedLink: {
//       color: '#447793',
//       textDecoration: 'none',
//       fontWeight: '600',
//       fontSize: '0.9rem',
//       display: 'inline-flex',
//       alignItems: 'center',
//       gap: '5px',
//     },
    
//     // Share Section
//     shareSection: {
//       backgroundColor: 'white',
//       padding: '20px',
//       borderRadius: '12px',
//       border: '1px solid #DDE8ED',
//     },
//     shareTitle: {
//       fontSize: '1.2rem',
//       fontWeight: '700',
//       color: '#123249',
//       marginBottom: '15px',
//     },
//     shareButtons: {
//       display: 'flex',
//       gap: '10px',
//       flexWrap: 'wrap',
//     },
//     shareButton: {
//       flex: 1,
//       minWidth: '100px',
//       padding: '10px',
//       borderRadius: '8px',
//       border: 'none',
//       backgroundColor: '#DDE8ED',
//       color: '#123249',
//       fontWeight: '600',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       gap: '8px',
//     },
    
//     // Loading State
//     loadingContainer: {
//       textAlign: 'center',
//       padding: '60px 20px',
//     },
//     loader: {
//       border: '4px solid #DDE8ED',
//       borderTop: '4px solid #447793',
//       borderRadius: '50%',
//       width: '50px',
//       height: '50px',
//       animation: 'spin 1s linear infinite',
//       margin: '0 auto 20px',
//     },
    
//     // Error State
//     errorContainer: {
//       textAlign: 'center',
//       padding: '60px 20px',
//       backgroundColor: '#DDE8ED',
//       borderRadius: '15px',
//     },
//   };

//   const keyframes = `
//     @keyframes spin {
//       0% { transform: rotate(0deg); }
//       100% { transform: rotate(360deg); }
//     }
//   `;

//   if (loading) {
//     return (
//       <div style={styles.container}>
//         <style>{keyframes}</style>
//         <div style={styles.loadingContainer}>
//           <div style={styles.loader}></div>
//           <p>Loading article...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error || !news) {
//     return (
//       <div style={styles.container}>
//         <div style={styles.errorContainer}>
//           <div style={{ fontSize: '3rem', marginBottom: '15px' }}>😕</div>
//           <h2>Article Not Found</h2>
//           <p>The news article you're looking for doesn't exist or has been removed.</p>
//           <button
//             onClick={() => navigate('/news')}
//             style={{
//               ...styles.backButton,
//               marginTop: '20px',
//             }}
//           >
//             ← Back to News
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.container}>
//       <style>{keyframes}</style>
      
//       {/* Back Button */}
//       <button
//         onClick={() => navigate('/news')}
//         style={styles.backButton}
//         onMouseEnter={(e) => {
//           e.currentTarget.style.backgroundColor = '#447793';
//           e.currentTarget.style.color = 'white';
//         }}
//         onMouseLeave={(e) => {
//           e.currentTarget.style.backgroundColor = 'transparent';
//           e.currentTarget.style.color = '#447793';
//         }}
//       >
//         ← Back to News
//       </button>

//       <div style={styles.mainContent}>
//         {/* Left Column - Main Article */}
//         <div style={styles.articleSection}>
//           <img
//             src={news.imageUrl || news.image || 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&h=400&fit=crop'}
//             alt={news.title}
//             style={styles.featuredImage}
//             onError={(e) => {
//               e.target.onerror = null;
//               e.target.src = 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&h=400&fit=crop';
//             }}
//           />
          
//           <div style={styles.articleContent}>
//             {/* Meta Information */}
//             <div style={styles.metaInfo}>
//               <span style={styles.categoryBadge}>
//                 <span>{getCategoryIcon(news.category)}</span>
//                 {news.category}
//               </span>
              
//               <div style={styles.metaItem}>
//                 <span>📅</span>
//                 {formatDate(news.date)}
//               </div>
              
//               <div style={styles.metaItem}>
//                 <span>👁️</span>
//                 {news.views || 0} views
//               </div>
//             </div>

//             {/* Title and Subtitle */}
//             <h1 style={styles.title}>{news.title}</h1>
//             {news.subtitle && (
//               <h2 style={styles.subtitle}>{news.subtitle}</h2>
//             )}

//             {/* Main Content */}
//             <div style={styles.content}>
//               {news.content}
//             </div>

//             {/* Source Information */}
//             {news.source && (
//               <div style={styles.sourceBox}>
//                 <div style={styles.metaItem}>
//                   <span>📌 Source:</span>
//                   <strong>{news.source}</strong>
//                 </div>
//                 {news.sourceUrl && (
//                   <a
//                     href={news.sourceUrl}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={styles.sourceLink}
//                   >
//                     <span>🔗</span>
//                     Read Original Article
//                   </a>
//                 )}
//               </div>
//             )}

//             {/* Tags */}
//             {news.tags && news.tags.length > 0 && (
//               <div style={styles.tagsContainer}>
//                 {news.tags.map((tag, index) => (
//                   <span key={index} style={styles.tag}>#{tag}</span>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Right Column - Sidebar */}
//         <div style={styles.sidebar}>
//           {/* Share Section */}
//           <div style={styles.shareSection}>
//             <h3 style={styles.shareTitle}>Share this Article</h3>
//             <div style={styles.shareButtons}>
//               <button
//                 style={styles.shareButton}
//                 onClick={() => {
//                   window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(news.title)}&url=${window.location.href}`, '_blank');
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.backgroundColor = '#447793';
//                   e.currentTarget.style.color = 'white';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.backgroundColor = '#DDE8ED';
//                   e.currentTarget.style.color = '#123249';
//                 }}
//               >
//                 <span>🐦</span> Twitter
//               </button>
              
//               <button
//                 style={styles.shareButton}
//                 onClick={() => {
//                   window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`, '_blank');
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.backgroundColor = '#447793';
//                   e.currentTarget.style.color = 'white';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.backgroundColor = '#DDE8ED';
//                   e.currentTarget.style.color = '#123249';
//                 }}
//               >
//                 <span>💼</span> LinkedIn
//               </button>
              
//               <button
//                 style={styles.shareButton}
//                 onClick={() => {
//                   window.open(`https://wa.me/?text=${encodeURIComponent(news.title + ' ' + window.location.href)}`, '_blank');
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.backgroundColor = '#25D366';
//                   e.currentTarget.style.color = 'white';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.backgroundColor = '#DDE8ED';
//                   e.currentTarget.style.color = '#123249';
//                 }}
//               >
//                 <span>📱</span> WhatsApp
//               </button>
//             </div>
//           </div>

//           {/* Related News */}
//           {relatedNews.length > 0 && (
//             <div style={styles.shareSection}>
//               <h3 style={styles.shareTitle}>Related News</h3>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                 {relatedNews.map((item) => (
//                   <div
//                     key={item._id}
//                     style={styles.relatedCard}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.transform = 'translateY(-5px)';
//                       e.currentTarget.style.boxShadow = '0 10px 25px rgba(68, 119, 147, 0.15)';
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.transform = 'translateY(0)';
//                       e.currentTarget.style.boxShadow = '0 5px 15px rgba(6, 18, 33, 0.08)';
//                     }}
//                   >
//                     <img
//                       src={item.imageUrl || item.image || 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=300&h=150&fit=crop'}
//                       alt={item.title}
//                       style={styles.relatedImage}
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.src = 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=300&h=150&fit=crop';
//                       }}
//                     />
//                     <div style={styles.relatedContent}>
//                       <h4 style={styles.relatedTitle}>{item.title}</h4>
//                       <div style={styles.relatedDate}>
//                         <span>📅</span>
//                         {formatDate(item.date)}
//                       </div>
//                       <Link
//                         to={`/news/${item._id}`}
//                         style={styles.relatedLink}
//                       >
//                         Read More →
//                       </Link>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NewsDetail;

























import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const NewsDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE_URL = 'http://localhost:5000/api';

  useEffect(() => {
    fetchNewsDetail();
  }, [id]);

  const fetchNewsDetail = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/news/${id}`);
      
      if (response.data.success) {
        setNews(response.data.data);
      }
    } catch (err) {
      console.error('Error fetching news:', err);
      setError('Failed to load news article');
    } finally {
      setLoading(false);
    }
  };

  // Format date
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'long' });
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    } catch {
      return dateString;
    }
  };

  const styles = {
    container: {
      maxWidth: '900px',
      margin: '0 auto',
      padding: '40px 20px',
      fontFamily: 'Cambria, serif',
      backgroundColor: '#ffffff',
    },
    
    // Back Button
    backButton: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      backgroundColor: 'transparent',
      color: '#447793',
      border: '2px solid #447793',
      padding: '10px 20px',
      borderRadius: '25px',
      fontSize: '0.95rem',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      textDecoration: 'none',
      marginBottom: '30px',
    },
    
    // Article Card
    articleCard: {
      backgroundColor: 'white',
      borderRadius: '15px',
      overflow: 'hidden',
      boxShadow: '0 5px 20px rgba(6, 18, 33, 0.08)',
      border: '1px solid #DDE8ED',
    },
    
    // Featured Image
    featuredImage: {
      width: '100%',
      height: '450px',
      objectFit: 'cover',
    },
    
    // Article Content
    articleContent: {
      padding: '40px',
    },
    
    // Meta Info
    metaInfo: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '20px',
      marginBottom: '20px',
      paddingBottom: '20px',
      borderBottom: '1px solid #DDE8ED',
    },
    metaItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      color: '#2D5A74',
      fontSize: '0.95rem',
    },
    source: {
      backgroundColor: '#DDE8ED',
      color: '#123249',
      padding: '5px 15px',
      borderRadius: '25px',
      fontSize: '0.9rem',
      fontWeight: '600',
    },
    
    // Title
    title: {
      fontSize: '2.5rem',
      fontWeight: '800',
      color: '#123249',
      marginBottom: '15px',
      lineHeight: '1.3',
    },
    headline: {
      fontSize: '1.3rem',
      color: '#447793',
      marginBottom: '25px',
      fontStyle: 'italic',
      borderLeft: '4px solid #447793',
      paddingLeft: '20px',
    },
    
    // Content
    content: {
      fontSize: '1.1rem',
      lineHeight: '1.8',
      color: '#2D5A74',
      marginBottom: '30px',
      whiteSpace: 'pre-line',
    },
    
    // Author Box
    authorBox: {
      backgroundColor: '#DDE8ED',
      padding: '20px',
      borderRadius: '10px',
      marginTop: '30px',
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
    },
    authorIcon: {
      fontSize: '2rem',
    },
    authorInfo: {
      flex: 1,
    },
    authorName: {
      fontSize: '1.1rem',
      fontWeight: '700',
      color: '#123249',
      marginBottom: '5px',
    },
    authorMeta: {
      color: '#2D5A74',
      fontSize: '0.9rem',
    },
    
    // Share Section
    shareSection: {
      marginTop: '40px',
      padding: '20px',
      backgroundColor: '#DDE8ED',
      borderRadius: '10px',
    },
    shareTitle: {
      fontSize: '1.1rem',
      fontWeight: '600',
      color: '#123249',
      marginBottom: '15px',
    },
    shareButtons: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap',
    },
    shareButton: {
      padding: '10px 20px',
      borderRadius: '25px',
      border: 'none',
      backgroundColor: 'white',
      color: '#123249',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    
    // Loading State
    loadingContainer: {
      textAlign: 'center',
      padding: '60px 20px',
    },
    loader: {
      border: '4px solid #DDE8ED',
      borderTop: '4px solid #447793',
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      animation: 'spin 1s linear infinite',
      margin: '0 auto 20px',
    },
    
    // Error State
    errorContainer: {
      textAlign: 'center',
      padding: '60px 20px',
      backgroundColor: '#DDE8ED',
      borderRadius: '15px',
    },
  };

  const keyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  if (loading) {
    return (
      <div style={styles.container}>
        <style>{keyframes}</style>
        <div style={styles.loadingContainer}>
          <div style={styles.loader}></div>
          <p>Loading article...</p>
        </div>
      </div>
    );
  }

  if (error || !news) {
    return (
      <div style={styles.container}>
        <div style={styles.errorContainer}>
          <div style={{ fontSize: '3rem', marginBottom: '15px' }}>😕</div>
          <h2>Article Not Found</h2>
          <p>The news article you're looking for doesn't exist or has been removed.</p>
          <button
            onClick={() => navigate('/news')}
            style={{
              ...styles.backButton,
              marginTop: '20px',
            }}
          >
            ← Back to News
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <style>{keyframes}</style>
      
      {/* Back Button */}
      <button
        onClick={() => navigate('/news')}
        style={styles.backButton}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#447793';
          e.currentTarget.style.color = 'white';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = '#447793';
        }}
      >
        ← Back to News
      </button>

      {/* Article Card */}
      <div style={styles.articleCard}>
        {/* Featured Image */}
        <img
          src={news.imageUrl || news.image || 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=900&h=450&fit=crop'}
          alt={news.title}
          style={styles.featuredImage}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=900&h=450&fit=crop';
          }}
        />

        {/* Content */}
        <div style={styles.articleContent}>
          {/* Meta Information */}
          <div style={styles.metaInfo}>
            {news.source && (
              <span style={styles.source}>
                📰 {news.source}
                {news.sourceLocation && `, ${news.sourceLocation}`}
              </span>
            )}
            <div style={styles.metaItem}>
              <span>📅</span>
              {formatDate(news.date)}
            </div>
            <div style={styles.metaItem}>
              <span>👁️</span>
              {news.views || 0} views
            </div>
          </div>

          {/* Title */}
          <h1 style={styles.title}>{news.title}</h1>
          
          {/* Headline */}
          {news.headline && (
            <div style={styles.headline}>{news.headline}</div>
          )}

          {/* Main Content */}
          <div style={styles.content}>
            {news.content}
          </div>

          {/* Author Information */}
          {news.author && (
            <div style={styles.authorBox}>
              <div style={styles.authorIcon}>✍️</div>
              <div style={styles.authorInfo}>
                <div style={styles.authorName}>{news.author}</div>
                <div style={styles.authorMeta}>Staff Writer</div>
              </div>
            </div>
          )}

          {/* Share Section */}
          <div style={styles.shareSection}>
            <div style={styles.shareTitle}>Share this article</div>
            <div style={styles.shareButtons}>
              <button
                style={styles.shareButton}
                onClick={() => {
                  window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(news.title)}&url=${window.location.href}`, '_blank');
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#447793';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'white';
                  e.currentTarget.style.color = '#123249';
                }}
              >
                <span>🐦</span> Twitter
              </button>
              
              <button
                style={styles.shareButton}
                onClick={() => {
                  window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`, '_blank');
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#447793';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'white';
                  e.currentTarget.style.color = '#123249';
                }}
              >
                <span>💼</span> LinkedIn
              </button>
              
              <button
                style={styles.shareButton}
                onClick={() => {
                  window.open(`https://wa.me/?text=${encodeURIComponent(news.title + ' ' + window.location.href)}`, '_blank');
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#25D366';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'white';
                  e.currentTarget.style.color = '#123249';
                }}
              >
                <span>📱</span> WhatsApp
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsDetail;